import { $ } from "@/common/Axios";

export default {
  /**
   * 学生反馈处理
   */
  studentFeedbackHandle_handle: {
    /*
     * 处理
     * id id (integer query required)
     * result 结果 (string query required)
     */
    put: (p, c) =>
      $.put("/api/zms/zhijiaotong/studentFeedbackHandle/handle", p, c),
  },
  studentFeedbackHandle_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/zms/zhijiaotong/studentFeedbackHandle/list", p, c),
  },
  studentFeedbackHandle_listByDomain: {
    /*
     * 列表-根据学校域名
     */
    get: (p, c) =>
      $.get("/api/zms/zhijiaotong/studentFeedbackHandle/listByDomain", p, c),
  },
  studentFeedbackHandle_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/zms/zhijiaotong/studentFeedbackHandle/details", p, c),
  },

  /**
   * 继教院平台页面
   */
  page_clearCourseMessage: {
    /*
     * 清楚首页到课数据
     * schoolRollId  (integer query required)
     */
    put: (p, c) => $.put("/api/zms/zhijiaotong/page/clearCourseMessage", p, c),
  },
  page_homePageForHeaderTeacher: {
    /*
     * 班主任首页数据
     */
    get: (p, c) =>
      $.get("/api/zms/zhijiaotong/page/homePageForHeaderTeacher", p, c),
  },
  page_homePageData: {
    /*
     * 学生首页数据
     */
    get: (p, c) => $.get("/api/zms/zhijiaotong/page/homePageData", p, c),
  },

  /**
   * 测评选项
   */
  assessmentOptions_setScoreMap: {
    /*
     * 设置分值配置
     * type 类型 (string query required)
     * scoreMap 分值配置 (string query required)
     */
    put: (p, c) =>
      $.put("/api/zms/zhijiaotong/assessmentOptions/setScoreMap", p, c),
  },
  assessmentOptions: {
    /*
     * 添加编辑
     * options  ( query required)
     */
    post: (p, c) => $.post("/api/zms/zhijiaotong/assessmentOptions", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/zhijiaotong/assessmentOptions", p, c),
  },
  assessmentOptions_upload: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/zms/zhijiaotong/assessmentOptions/upload", p, c),
  },
  assessmentOptions_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/zhijiaotong/assessmentOptions/list", p, c),
  },
  assessmentOptions_listType: {
    /*
     * 类型列表
     */
    get: (p, c) =>
      $.get("/api/zms/zhijiaotong/assessmentOptions/listType", p, c),
  },
  assessmentOptions_getScoreMap: {
    /*
     * 获取分值配置
     * type 类型 (string query required)
     */
    get: (p, c) =>
      $.get("/api/zms/zhijiaotong/assessmentOptions/getScoreMap", p, c),
  },
  assessmentOptions_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/zhijiaotong/assessmentOptions/export", p, c),
  },

  /**
   * 职教学期信息
   */
  term: {
    /*
     * 添加编辑
     * term  ( query required)
     */
    post: (p, c) => $.post("/api/zms/zhijiaotong/term", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/zhijiaotong/term", p, c),
  },
  term_upload: {
    /*
     * 导入
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/zms/zhijiaotong/term/upload", p, c),
  },
  term_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/zhijiaotong/term/list", p, c),
  },
  term_listSimple: {
    /*
     * 简易列表
     * majorId 专业id (integer query required)
     * batch 批次 (string query required)
     */
    get: (p, c) => $.get("/api/zms/zhijiaotong/term/listSimple", p, c),
  },
  term_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/zhijiaotong/term/export", p, c),
  },

  /**
   * 学生反馈
   */
  studentFeedback: {
    /*
     * 提交反馈
     * type 类型 (string query required)
     * content 内容 (string query required)
     * attach 附件 (string query )
     */
    post: (p, c) => $.post("/api/zms/zhijiaotong/studentFeedback", p, c),
  },

  /**
   * 学生反馈类别
   */
  studentFeedbackType: {
    /*
     * 添加
     * feedbackType  ( query required)
     */
    post: (p, c) => $.post("/api/zms/zhijiaotong/studentFeedbackType", p, c),
  },
  studentFeedbackType_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/zhijiaotong/studentFeedbackType/list", p, c),
  },
  studentFeedbackType_listName: {
    /*
     * 名称列表
     * ableStatus 启用状态 (string query )
     */
    get: (p, c) =>
      $.get("/api/zms/zhijiaotong/studentFeedbackType/listName", p, c),
  },

  /**
   * 学生测评结果
   */
  assessmentStudent_refreshNotice: {
    /*
     * 刷新通知
     */
    post: (p, c) =>
      $.post("/api/zms/zhijiaotong/assessmentStudent/refreshNotice", p, c),
  },
  assessmentStudent_hand: {
    /*
     * 提交测评结果
     * assessmentId 测评id (integer query required)
     * contents 结果，排序好 (array query required)
     * suggestions 意见建议 (string query required)
     */
    post: (p, c) => $.post("/api/zms/zhijiaotong/assessmentStudent/hand", p, c),
  },
  assessmentStudent_list: {
    /*
     * 列表
     * status 状态：进行中，已结束，全部则不传 (string query )
     */
    get: (p, c) => $.get("/api/zms/zhijiaotong/assessmentStudent/list", p, c),
  },
  assessmentStudent_listUnHandName: {
    /*
     * 未提交测评名单
     * assessmentId 测评id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/zms/zhijiaotong/assessmentStudent/listUnHandName", p, c),
  },
  assessmentStudent_details: {
    /*
     * 详情
     * assessmentId 测评id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/zms/zhijiaotong/assessmentStudent/details", p, c),
  },

  /**
   * 测评
   */
  assessment_open: {
    /*
     * 开启（单个）
     * assessment  ( query required)
     */
    post: (p, c) => $.post("/api/zms/zhijiaotong/assessment/open", p, c),
  },
  assessment_batchOpen: {
    /*
     * 开启（批量）
     * siteId 学校id (integer query required)
     * type 类型（专业课老师教学测评、班主任老师服务态度测评） (string query required)
     * startTime 开始时间 (string query required)
     * endTime 结束时间 (string query required)
     */
    post: (p, c) => $.post("/api/zms/zhijiaotong/assessment/batchOpen", p, c),
  },
  assessment_listForTeacher: {
    /*
     * 列表（讲师）
     */
    get: (p, c) =>
      $.get("/api/zms/zhijiaotong/assessment/listForTeacher", p, c),
  },
  assessment_listForTeacherByDomain: {
    /*
     * 列表（讲师）
     */
    get: (p, c) =>
      $.get("/api/zms/zhijiaotong/assessment/listForTeacherByDomain", p, c),
  },
  assessment_listForHeaderTeacher: {
    /*
     * 列表（班主任）
     */
    get: (p, c) =>
      $.get("/api/zms/zhijiaotong/assessment/listForHeaderTeacher", p, c),
  },
  assessment_listForHeaderTeacherByDomain: {
    /*
     * 列表（班主任）
     */
    get: (p, c) =>
      $.get(
        "/api/zms/zhijiaotong/assessment/listForHeaderTeacherByDomain",
        p,
        c
      ),
  },
  assessment_exportForTeacher: {
    /*
     * 导出（讲师）
     */
    get: (p, c) =>
      $.get("/api/zms/zhijiaotong/assessment/exportForTeacher", p, c),
  },
  assessment_exportForTeacherByDomain: {
    /*
     * 导出（讲师）
     */
    get: (p, c) =>
      $.get("/api/zms/zhijiaotong/assessment/exportForTeacherByDomain", p, c),
  },
  assessment_exportForHeaderTeacher: {
    /*
     * 导出（班主任）
     */
    get: (p, c) =>
      $.get("/api/zms/zhijiaotong/assessment/exportForHeaderTeacher", p, c),
  },
  assessment_exportForHeaderTeacherByDomain: {
    /*
     * 导出（班主任）
     */
    get: (p, c) =>
      $.get(
        "/api/zms/zhijiaotong/assessment/exportForHeaderTeacherByDomain",
        p,
        c
      ),
  },
  assessment_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/zms/zhijiaotong/assessment/details", p, c),
  },
  assessment: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/zhijiaotong/assessment", p, c),
  },
};
